import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Login() {
  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [error, setError]       = useState('')
  const [loading, setLoading]   = useState(false)

  const handleLogin = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(error.message)
    setLoading(false)
  }

  return (
    <div className="auth-layout">
      {/* Left panel */}
      <div className="auth-panel">
        <div className="auth-panel-content">
          <div className="auth-logo">
            <div className="auth-logo-mark">↑</div>
            <span className="auth-logo-name">Uplift</span>
          </div>
          <h1>Helping people, one record at a time</h1>
          <p>A secure platform to register your details and stay connected with the support services available to you.</p>
          <div className="auth-panel-features">
            <div className="auth-feature">
              <div className="auth-feature-icon">🔒</div>
              Your data is private and secure
            </div>
            <div className="auth-feature">
              <div className="auth-feature-icon">✏️</div>
              Update your information anytime
            </div>
            <div className="auth-feature">
              <div className="auth-feature-icon">🤝</div>
              Connect with the right support
            </div>
          </div>
        </div>
      </div>

      {/* Right panel */}
      <div className="auth-form-side">
        <div className="auth-card">
          <div className="auth-card-logo">
            <div className="auth-card-logo-mark">↑</div>
            <span className="auth-card-logo-name">Uplift</span>
          </div>
          <h2>Welcome back</h2>
          <p className="subtitle">Sign in to view or update your profile</p>

          {error && <div className="alert alert-error">⚠ {error}</div>}

          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label>Email address</label>
              <input
                type="email" required
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com"
                autoComplete="email"
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password" required
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign in →'}
            </button>

            <div style={{ textAlign: 'right', marginTop: 12 }}>
              <Link to="/forgot-password" style={{ fontSize: '0.85rem', color: 'var(--uplift)', textDecoration: 'none', fontWeight: 600 }}>
                Forgot your password?
              </Link>
            </div>
          </form>

          <div className="auth-link">
            Don't have an account? <Link to="/register">Register here</Link>
          </div>
        </div>
      </div>
    </div>
  )
}
